const fields = ['recipient_street_address', 'recipient_city', 'recipient_state', 'recipient_zip_code'];
const reasons = new Set(['review_required', 'proposal_changed', 'lookup_unavailable', 'saved_address_changed']);
export const validAddressProposal = value => value?.version === 1
  && Object.keys(value).length === 4
  && ['context', 'baseline', 'result'].every(key => typeof value[key] === 'string' && /^[a-f0-9]{64}$/.test(value[key]));

// A comparison reference is not permission or a saved-order receipt.
export function addressReviewFrom(error) {
  const detail = error?.response?.data?.detail;
  if (error?.response?.status !== 409 || detail?.code !== 'address_confirmation_required') return null;
  if (fields.some(key => detail.difference?.[key] != null
      && (typeof detail.difference[key]?.entered !== 'string' || typeof detail.difference[key]?.proposed !== 'string'))) return null;
  const difference = Object.fromEntries(fields.filter(key => {
    const row = detail.difference?.[key];
    return typeof row?.entered === 'string' && typeof row?.proposed === 'string';
  }).map(key => [key, { entered: detail.difference[key].entered, proposed: detail.difference[key].proposed }]));
  const proposal = validAddressProposal(detail.proposal) ? { ...detail.proposal } : null;
  if (!Object.keys(difference).length && !reasons.has(detail.reason)) return null;
  return { difference, proposal,
    reason: !proposal && !['saved_address_changed', 'lookup_unavailable'].includes(detail.reason)
      ? 'client_update_required' : reasons.has(detail.reason) ? detail.reason : 'review_required' };
}

export function addressAcceptance(review) {
  return review?.reason !== 'saved_address_changed' && validAddressProposal(review?.proposal)
    ? { accept_canonical_address: true, address_confirmation: { ...review.proposal } } : null;
}
